// extracted by mini-css-extract-plugin
export default {"bottom":"PageBody_bottom__BxAbk","headerAndDescription":"PageBody_headerAndDescription__iFZIz","top":"PageBody_top__heGPp"};